export default "__VITE_ASSET__BEDpIyuW__"